import WithdrawalStatusModal from './WithdrawalStatusModal.container'
export default WithdrawalStatusModal
